import { Injectable } from '@angular/core';
import { from, Observable, ReplaySubject } from 'rxjs';
import { cloneDeep } from 'lodash-es';

const DEFAULT_TAILWIND_CONFIG = {
    breakpoints: {
        print: 'print',
        sm: '(min-width: 600px)',
        md: '(min-width: 960px)',
        lg: '(min-width: 1280px)',
        xl: '(min-width: 1440px)'
    },
    themes: {
        default: {},
        brand: {},
        indigo: {},
        rose: {},
        purple: {},
        amber: {}
    }
};

@Injectable()
export class FuseTailwindService {
    private _tailwindConfig: ReplaySubject<any> = new ReplaySubject<any>(1);

    /**
     * Constructor
     */
    constructor() {
        this._tailwindConfig.next(cloneDeep(DEFAULT_TAILWIND_CONFIG));
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for _tailwindConfig
     */
    get tailwindConfig$(): Observable<any> {
        return this._tailwindConfig.asObservable() ?? from("");
    }
}
